<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('tel22')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="search">
                        <div class="searchleft">
                            <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                                <el-form-item :label="$t('time')">
                                    <el-date-picker
                                    v-model="value1"
                                    type="daterange"
                                    size="small"
                                    @change="checkdata"
                                    range-separator="至"
                                    value-format="yyyy-MM-dd"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item :label="$t('tel66')">
                                    <el-select size="small" v-model="searchform.principalId" filterable :placeholder="$t('qxz')">
                                        <el-option :label="$t('qxz')" :value="null"></el-option>
                                        <el-option v-for="item in principallist"
                                            :key="item.id"
                                            :label="item.nickName"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                                    <el-button size="small" type="primary" @click="exportDate">{{$t('tel84')}}</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <el-table :data="list" 
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}">
                        <el-table-column prop="time" :label="$t('tel7')"></el-table-column>
                        <el-table-column prop="telemarketingName" :label="$t('tel23')"></el-table-column>
                        <!-- <el-table-column prop="customerGroupType" :label="$t('tel24')"></el-table-column> -->
                        <el-table-column prop="suborderQuantity" :label="$t('tel25')"></el-table-column>
                        <el-table-column prop="outgoingCallVolume" :label="$t('tel26')"></el-table-column>
                        <el-table-column prop="outgoingCallRate" :label="$t('tel27')"></el-table-column>
                        <el-table-column prop="totalNumberOfOutgoingCalls" :label="$t('tel28')"></el-table-column>
                        <el-table-column prop="averageNumberOfCallsPerItem" :label="$t('tel29')"></el-table-column>
                        <el-table-column prop="telephoneConnectionVolume" :label="$t('tel30')"></el-table-column>
                        <el-table-column prop="telephoneConnectionRate" :label="$t('tel31')"></el-table-column>
                        <el-table-column prop="totailCallTime" label="总通话时间"></el-table-column>
                        <el-table-column prop="applicationNumber" :label="$t('value4')"></el-table-column>
                        <el-table-column prop="applicationRate" :label="$t('tel33')"></el-table-column>
                        <el-table-column prop="waSendingQuantity" :label="$t('tel34')"></el-table-column>
                    </el-table>
                    <div class="page">
                        <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                loading: false,
                list: [],
                searchform:{},
                total: 1,
                pageNo: 1,
                pageSize: 10,
                value1:null,
                principallist:[],
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.value1 = this.getNowTime()
            this.getprincipal()
            this.getList()
        },
        methods: {
            getNowTime() {
                const start = new Date(new Date().getTime())
                    .toISOString()
                    .replace('T', ' ')
                    .split('.')[0] //默认开始时间7天前
                const end = new Date(new Date().getTime())
                    .toISOString()
                    .replace('T', ' ')
                    .split('.')[0]//默认结束时间1天前
                return [start, end]
            },
            getprincipal() {
                _api.get(apiurl.users, {
                    roleId: 5,
                }).then(res => {
                    this.principallist = res.content
                })
            },
            getList() {
                this.loading = true
                _api.get(apiurl.telWorkTotal, {
                    page: this.pageNo,
                    size: this.pageSize,
                    createTime: this.value1,
                    principalId: this.searchform.principalId,
                }).then(res => {
                    this.loading = false
                    this.list = res.data.data
                    this.total = res.data.totalCount
                })
            },
            exportDate() {
                _api.download(apiurl.exportWorkDate, {
                    page: this.pageNo,
                    size: this.pageSize,
                    createTime: this.value1,
                    principalId: this.searchform.principalId,
                }).then(res => {
                    let a = document.createElement('a');
                    let blob = new Blob([res], {type: "application/vnd.ms-excel"});
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '电销工作量统计数据.xls');
                    a.click();
                })
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                this.pageNo = data
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>